'use strict';

import cx from 'classnames';
import React, {PropTypes} from 'react';

export default class AccordionListItem extends React.Component {
    static propTypes = {
      index: PropTypes.number,
      onToggle: PropTypes.func,
      openIndex: PropTypes.number,
      title: React.PropTypes.node,
      titleLead: PropTypes.string,
      /*title: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.node,
      ]),*/
      done: PropTypes.bool,
      itemKey: PropTypes.string,
      onSave: PropTypes.func,
      toggleOpenedText: PropTypes.string,
      showCheckMark: PropTypes.bool,
      hideAllOnOpen: PropTypes.bool
    }

    static defaultProps = {
      showCheckMark: true,
      toggleOpenedText: 'Save',
      hideAllOnOpen: true
    }

    getFormattedTitle() {
      if (this.props.titleLead) {
        return <div><strong>{this.props.titleLead}</strong> {this.props.title}</div>;
      } else {
        return this.props.title;
      }
    }

    constructor(props) {
      super(props);
    }

    render() {
      const accordionIsOpen = (this.props.openIndex !== null);
      const handleClose = () => accordionIsOpen && this.props.onSave && this.props.onSave();
      const panelIsOpen = (this.props.openIndex === this.props.index);
      const hide = this.props.hideAllOnOpen && accordionIsOpen && !panelIsOpen;

      return (
        !hide
        &&
        <div className={cx('accordion-panel-container', {open: panelIsOpen})}>
          <div className='accordion-panel-header'
            onClick={this.props.onToggle} >
            <div className='left'>
              { this.props.showCheckMark && <div className={cx('checkbox', {checkmark: this.props.done})}></div> }
              <div className='accordion-text noTextSelect'>
                  {this.getFormattedTitle()}
              </div>
            </div>
            <div className='right'
              onClick={() => {handleClose(); this.props.onToggle(); }} >
              <div className={cx('accordion-toggle')}>
                <div className={cx('accordion-toggle-text', 'noTextSelect')}>
                  {panelIsOpen ? this.props.toggleOpenedText : 'View'}
                </div>
              </div>
              <div className='accordion-caret-container'>
                <div className={cx('accordion-toggle-caret', 'chevron', 'toggled')} ></div>
              </div>
            </div>
          </div>
          {
            panelIsOpen
            &&
            <div className={cx('accordion-item', 'expanded-accordion', 'expanded-accordion-content')}>
              {this.props.children}
            </div>
          }
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./shared/common/components/AccordionList/AccordionListItem.js